import { render, staticRenderFns } from "./PricingForms.vue?vue&type=template&id=779b6dd9&scoped=true"
import script from "./PricingForms.vue?vue&type=script&lang=js"
export * from "./PricingForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b6dd9",
  null
  
)

export default component.exports